/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "visibility",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#666766"
            },
            "visibility": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "15",
            "height": "8.3"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 8.3", className: "visibility", width: this.props.width, height: this.props.height, style: this.props.visibility },
            _react2["default"].createElement("path", { className: "st0", d: "M7.5 0C3.1 0 0 4.1 0 4.1s3.1 4.1 7.5 4.1S15 4.1 15 4.1 11.9 0 7.5 0zm0 7.2c-1.7 0-3.1-1.4-3.1-3.1S5.8 1 7.5 1s3.1 1.4 3.1 3.1-1.4 3.1-3.1 3.1z", style: this.props.st0 }),
            _react2["default"].createElement("circle", { className: "st0", cx: "7.5", cy: "4.1", r: "1.9", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/visibility.js